import React from 'react'

const Manual_forma_envio_region = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configurar forma de envío "Entrega por región"
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Descubre cómo configurar entregas específicas por región dentro del portal de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configurar_forma_de_envio_Entrega_por_region__X-9U0fXgRPK-9szgZ_0B_g?as=scrollable"
          className="scribe-iframe-general-109"
          width="100%"
          height="6700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_forma_envio_region
